import type { UpdateUserBody } from '@si/types';
import { patch } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

export function useUpdateUser() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: (params: UpdateUserBody) =>
      patch({
        url: '/users/current',
        body: { ...params },
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: queryKeys.getUser('current'),
      }),
  });

  const updateUser = useCallback((params: UpdateUserBody) => mutate(params), [mutate]);

  return {
    updateUser,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
